import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/24/outline";

import AddShopBrandsForm from "./AddShopBrandsForm";
import ShopBrandsTableDetails from "./ShopBrandsTableDetails";
import {
  deleteShopBrandById,
  fetchAllShopBrands,
} from "../../../../redux/reducer/shopBrandReducer";

const ShopBrandsSettings = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const dispatch = useDispatch();
  const { allShopBrands, loading, error } = useSelector(
    (state) => state.shopBrand
  );
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);

  const headers = ["ID", "Name EN", "Name AR", "Link", "image", "Actions"];

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllShopBrands());
    };

    fetchData();
  }, [dispatch]);

  const loadShopping = async () => {
    try {
      await dispatch(fetchAllShopBrands()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the Shopping:", error);
    }
  };

  const handleDelete = (shoppingId) => {
    if (window.confirm("Are you sure you want to delete this Shopping?")) {
      dispatch(deleteShopBrandById(shoppingId))
        .unwrap()
        .then(() => {
          // alert(t("shoppingDeleted"));
          dispatch(fetchAllShopBrands());
        })
        .catch((error) => alert(error || "Failed to delete Shopping."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllShopBrands());
  };

  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">Shop Brands</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-md bg-custom-yellow hover:bg-black group"
          onClick={() => {
            setShowForm(true);
          }}
        >
          <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
          <span className="text-black group-hover:text-white">Add an item</span>
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allShopBrands?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {allShopBrands?.map((shopping, index) => (
              <ShopBrandsTableDetails
                key={shopping._id || index}
                index={index + 1}
                details={{
                  id: shopping._id,
                  number: index + 1,
                  img: shopping.img,
                  link: shopping.link,
                  nameEN: shopping.title?.en,
                  nameAR: shopping.title?.ar,
                }}
                isEditing={editingOrder === shopping._id}
                isPricing={pricingOrder === shopping._id}
                setEditingOrder={setEditingOrder}
                setPricingOrder={setPricingOrder}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(shopping._id)}
              />
            ))}
          </tbody>
        </table>
      )}
      {showForm && (
        <AddShopBrandsForm
          onClose={() => {
            setShowForm(false);
            loadShopping();
          }}
        />
      )}
    </div>
  );
};

export default ShopBrandsSettings;
